//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class DataLinkModel extends ModelBase {
      static readonly $typeName = 'DataLinkModel';
      public key: string;
      public isActive: boolean;
      public inRule: boolean;
      public propertyKey: string;
      public enforced: boolean;
      public parentDataLinkKey: string;
      public targetEntity: string;
      public targetDataSet: string;
      public targetField: string;
      public description: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/models/DataLinkModel.ts